import Service from './Service';
import UserAccount from './UserAccount';

class CreateContentPopup extends Service {
  __open = false;
  __intent = 'blank';
  __collection = null;
  __team = null;
  __openTemplatesOnMount = false;

  open({
    intent = 'blank',
    collection = null,
    team = null,
    openTemplatesOnMount = false,
  } = {}) {
    this.__open = true;
    this.__intent = intent;
    this.__collection = collection || null;
    this.__team = team || null;
    this.__openTemplatesOnMount = !!openTemplatesOnMount;
    this.emitStateUpdate();
  }

  close() {
    if (!this.__open) return;
    this.__open = false;
    this.__collection = null;
    this.__team = null;
    this.__openTemplatesOnMount = false;
    this.emitStateUpdate();
  }

  get isOpen() {
    return this.__open;
  }

  get intent() {
    return this.__intent;
  }

  get collection() {
    return this.__collection;
  }

  get team() {
    return this.__team;
  }

  get openTemplatesOnMount() {
    return this.__openTemplatesOnMount;
  }
}

const singleton = new CreateContentPopup();

UserAccount.onStateUpdate(() => {
  if (!UserAccount.isLoggedIn) singleton.close();
});

export default singleton;
